module.exports = __webpack_public_path__ + "static/media/Intersection 33.e272229c.png";